import { useBreakpoint } from '@shared/useBreakpoints';

const EmptyTourbooksStateIllustration = () => {
  const { isMobile } = useBreakpoint();

  return (
    <>
      {isMobile ? (
        <svg
          width="375"
          height="306"
          viewBox="0 0 375 306"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_dd_3921_11748)">
            <g clipPath="url(#clip0_3921_11748)">
              <path d="M293.803 166.373H166.068V273.001H293.803V166.373Z" fill="white" />
              <path d="M351 129H159V273.072H351V129Z" fill="white" />
              <path d="M351 129.383H159V159.754H351V129.383Z" fill="#EAEAEA" />
              <path d="M343.396 131.449H165.543V143.422H343.396V131.449Z" fill="white" />
              <path
                d="M177.95 133.049H168.515C167.746 133.049 167.123 133.678 167.123 134.453V140.584C167.123 141.359 167.746 141.988 168.515 141.988H177.95C178.719 141.988 179.342 141.359 179.342 140.584V134.453C179.342 133.678 178.719 133.049 177.95 133.049Z"
                fill="url(#paint0_linear_3921_11748)"
              />
              <path d="M343.396 145.225H165.543V157.197H343.396V145.225Z" fill="white" />
              <path
                d="M177.95 146.82H168.515C167.746 146.82 167.123 147.449 167.123 148.225V154.355C167.123 155.131 167.746 155.76 168.515 155.76H177.95C178.719 155.76 179.342 155.131 179.342 154.355V148.225C179.342 147.449 178.719 146.82 177.95 146.82Z"
                fill="url(#paint1_linear_3921_11748)"
              />
              <path
                d="M222.991 167.854H172.294C171.526 167.854 170.902 168.482 170.902 169.258V174.198C170.902 174.974 171.526 175.602 172.294 175.602H222.991C223.76 175.602 224.383 174.974 224.383 174.198V169.258C224.383 168.482 223.76 167.854 222.991 167.854Z"
                fill="#AAAAAA"
              />
              <path
                d="M207.083 178.471H172.294C171.526 178.471 170.902 179.099 170.902 179.875V180.939C170.902 181.715 171.526 182.343 172.294 182.343H207.083C207.851 182.343 208.475 181.715 208.475 180.939V179.875C208.475 179.099 207.851 178.471 207.083 178.471Z"
                fill="#AAAAAA"
              />
              <path
                d="M250.105 256.027H172.294C171.526 256.027 170.902 256.656 170.902 257.432V258.734C170.902 259.51 171.526 260.139 172.294 260.139H250.105C250.874 260.139 251.497 259.51 251.497 258.734V257.432C251.497 256.656 250.874 256.027 250.105 256.027Z"
                fill="#D5D6D5"
              />
              <path
                d="M225.803 262.836H172.295C171.526 262.836 170.903 263.465 170.903 264.24V265.543C170.903 266.319 171.526 266.947 172.295 266.947H225.803C226.572 266.947 227.195 266.319 227.195 265.543V264.24C227.195 263.465 226.572 262.836 225.803 262.836Z"
                fill="#D5D6D5"
              />
              <path
                d="M281.026 172.646C281.026 174.51 279.46 176.034 277.546 176.034H263.538C261.624 176.034 260.058 174.51 260.058 172.646C260.058 170.782 261.624 169.258 263.538 169.258H277.546C279.46 169.258 281.026 170.782 281.026 172.646Z"
                fill="#D5D6D5"
              />
              <path
                d="M288.207 175.684C289.839 175.684 291.161 174.35 291.161 172.704C291.161 171.057 289.839 169.723 288.207 169.723C286.575 169.723 285.252 171.057 285.252 172.704C285.252 174.35 286.575 175.684 288.207 175.684Z"
                fill="#D5D6D5"
              />
              <path
                d="M222.991 191.146H172.294C171.526 191.146 170.902 191.775 170.902 192.551V249.813C170.902 250.589 171.526 251.218 172.294 251.218H222.991C223.76 251.218 224.383 250.589 224.383 249.813V192.551C224.383 191.775 223.76 191.146 222.991 191.146Z"
                fill="url(#paint2_linear_3921_11748)"
              />
              <path
                d="M254.278 191.605H232.61C231.841 191.605 231.218 192.234 231.218 193.01V214.894C231.218 215.67 231.841 216.299 232.61 216.299H254.278C255.047 216.299 255.67 215.67 255.67 214.894V193.01C255.67 192.234 255.047 191.605 254.278 191.605Z"
                fill="url(#paint3_linear_3921_11748)"
              />
              <path
                d="M254.278 225.436H232.61C231.841 225.436 231.218 226.064 231.218 226.84V248.725C231.218 249.5 231.841 250.129 232.61 250.129H254.278C255.047 250.129 255.67 249.5 255.67 248.725V226.84C255.67 226.064 255.047 225.436 254.278 225.436Z"
                fill="url(#paint4_linear_3921_11748)"
              />
              <path
                d="M285.736 191.605H264.068C263.299 191.605 262.676 192.234 262.676 193.01V214.894C262.676 215.67 263.299 216.299 264.068 216.299H285.736C286.505 216.299 287.128 215.67 287.128 214.894V193.01C287.128 192.234 286.505 191.605 285.736 191.605Z"
                fill="url(#paint5_linear_3921_11748)"
              />
              <path
                d="M285.736 225.436H264.068C263.299 225.436 262.676 226.064 262.676 226.84V248.725C262.676 249.5 263.299 250.129 264.068 250.129H285.736C286.505 250.129 287.128 249.5 287.128 248.725V226.84C287.128 226.064 286.505 225.436 285.736 225.436Z"
                fill="url(#paint6_linear_3921_11748)"
              />
              <path d="M351 159.754H297.666V272.214H351V159.754Z" fill="#EFEFEF" />
              <path
                d="M351 172.076C351 172.076 330.094 172.778 324.335 193.02C324.335 193.02 321.199 221.997 297.669 224.809V230.613C297.669 230.613 318.718 230.56 327.251 208.061C327.251 208.061 329.812 198.869 331.518 191.847C331.518 191.847 337.49 177.659 351.003 178.47V172.076H351Z"
                fill="#C2E5EF"
              />
              <path
                d="M297.666 246.397L334.928 238.81L345.832 211.964L351 209.668V214.257L348.581 215.984L339.195 240.372L351 257.015V264.192L335.214 243.659L297.666 250.516V246.397Z"
                fill="white"
              />
              <path
                d="M329.321 255.765L297.938 263.083V273.074H342.328C342.328 273.074 347.701 270.326 342.328 264.495L334.13 255.765C334.13 255.765 332.67 254.984 329.325 255.765H329.321Z"
                fill="url(#paint7_linear_3921_11748)"
              />
              <path
                d="M336.039 222.002C338.437 222.002 340.382 220.04 340.382 217.62C340.382 215.2 338.437 213.238 336.039 213.238C333.64 213.238 331.695 215.2 331.695 217.62C331.695 220.04 333.64 222.002 336.039 222.002Z"
                fill="#600AFF"
              />
              <path
                d="M306.533 187.814C308.932 187.814 310.877 185.853 310.877 183.433C310.877 181.013 308.932 179.051 306.533 179.051C304.135 179.051 302.19 181.013 302.19 183.433C302.19 185.853 304.135 187.814 306.533 187.814Z"
                fill="#600AFF"
              />
              <path
                d="M318.592 184.178C320.991 184.178 322.935 182.216 322.935 179.796C322.935 177.376 320.991 175.414 318.592 175.414C316.193 175.414 314.249 177.376 314.249 179.796C314.249 182.216 316.193 184.178 318.592 184.178Z"
                fill="#600AFF"
              />
              <path
                d="M312.262 255.359C314.661 255.359 316.605 253.398 316.605 250.978C316.605 248.558 314.661 246.596 312.262 246.596C309.863 246.596 307.918 248.558 307.918 250.978C307.918 253.398 309.863 255.359 312.262 255.359Z"
                fill="#600AFF"
              />
              <path
                d="M324.331 253.379C326.73 253.379 328.674 251.417 328.674 248.997C328.674 246.577 326.73 244.615 324.331 244.615C321.932 244.615 319.988 246.577 319.988 248.997C319.988 251.417 321.932 253.379 324.331 253.379Z"
                fill="#600AFF"
              />
              <path
                d="M297.318 179.535L315.603 174.121L335.691 159.754H328.153L313.16 170.287L297.318 175.199V179.535Z"
                fill="white"
              />
            </g>
          </g>
          <g filter="url(#filter1_dd_3921_11748)">
            <g clipPath="url(#clip1_3921_11748)">
              <path d="M216 114.736H24V156.001H216V114.736Z" fill="#EAEAEA" />
              <path d="M216 15H24V114.735H216V15Z" fill="white" />
              <path
                d="M138.283 85.0684H24V114.735H138.283V85.0684Z"
                fill="url(#paint8_linear_3921_11748)"
              />
              <path
                d="M141.349 15L124.693 114.735H216V15H141.349Z"
                fill="url(#paint9_linear_3921_11748)"
              />
              <path
                d="M136.985 41.1342L163.661 47.4914H196.657L216 32.9413V15H141.349L136.985 41.1342Z"
                fill="url(#paint10_linear_3921_11748)"
              />
              <path d="M196.657 47.4922H163.661V72.292H196.657V47.4922Z" fill="white" />
              <path
                d="M216 79.5559V114.737H124.693L131.229 75.6047L163.661 72.293H196.657L216 79.5559Z"
                fill="url(#paint11_linear_3921_11748)"
              />
              <path
                d="M98.8074 35.3716C98.8074 36.1321 98.181 36.7544 97.4153 36.7544H31.9351C31.1694 36.7544 30.543 36.1321 30.543 35.3716V30.5078C30.543 29.7472 31.1694 29.125 31.9351 29.125H97.4153C98.181 29.125 98.8074 29.7472 98.8074 30.5078V35.3716Z"
                fill="#AAAAAA"
              />
              <path
                d="M82.6314 41.1348H31.9351C31.1662 41.1348 30.543 41.7538 30.543 42.5175V47.3814C30.543 48.1451 31.1662 48.7641 31.9351 48.7641H82.6314C83.4002 48.7641 84.0234 48.1451 84.0234 47.3814V42.5175C84.0234 41.7538 83.4002 41.1348 82.6314 41.1348Z"
                fill="#AAAAAA"
              />
              <path
                d="M46.2283 70.3555H31.9351C31.1662 70.3555 30.543 70.9746 30.543 71.7382V74.2203C30.543 74.984 31.1662 75.603 31.9351 75.603H46.2283C46.9971 75.603 47.6204 74.984 47.6204 74.2203V71.7382C47.6204 70.9746 46.9971 70.3555 46.2283 70.3555Z"
                fill="#AAAAAA"
              />
              <path
                d="M74.8666 94.5195H54.4795C53.7107 94.5195 53.0874 95.1386 53.0874 95.9023V97.9764C53.0874 98.7401 53.7107 99.3592 54.4795 99.3592H74.8666C75.6354 99.3592 76.2587 98.7401 76.2587 97.9764V95.9023C76.2587 95.1386 75.6354 94.5195 74.8666 94.5195Z"
                fill="#CECECE"
              />
              <path
                d="M74.8668 101.777H54.4797C53.7109 101.777 53.0876 102.396 53.0876 103.16V105.234C53.0876 105.998 53.7109 106.617 54.4797 106.617H74.8668C75.6357 106.617 76.2589 105.998 76.2589 105.234V103.16C76.2589 102.396 75.6357 101.777 74.8668 101.777Z"
                fill="#CECECE"
              />
              <path
                d="M71.8807 118.811H31.9348C31.166 118.811 30.5427 119.43 30.5427 120.193V122.675C30.5427 123.439 31.166 124.058 31.9348 124.058H71.8807C72.6495 124.058 73.2728 123.439 73.2728 122.675V120.193C73.2728 119.43 72.6495 118.811 71.8807 118.811Z"
                fill="#AAAAAA"
              />
              <path d="M208.396 128.139H30.543V139.927H208.396V128.139Z" fill="white" />
              <path
                d="M61.2273 79.5535C66.6937 79.5535 71.1251 75.1518 71.1251 69.722C71.1251 64.2923 66.6937 59.8906 61.2273 59.8906C55.761 59.8906 51.3296 64.2923 51.3296 69.722C51.3296 75.1518 55.761 79.5535 61.2273 79.5535Z"
                fill="url(#paint12_linear_3921_11748)"
              />
              <path
                d="M37.5103 104.932C41.1469 104.932 44.0949 102.004 44.0949 98.392C44.0949 94.7798 41.1469 91.8516 37.5103 91.8516C33.8738 91.8516 30.9258 94.7798 30.9258 98.392C30.9258 102.004 33.8738 104.932 37.5103 104.932Z"
                fill="url(#paint13_linear_3921_11748)"
              />
              <path
                d="M44.3456 109.127C47.0865 109.127 49.3084 106.92 49.3084 104.197C49.3084 101.475 47.0865 99.2676 44.3456 99.2676C41.6047 99.2676 39.3828 101.475 39.3828 104.197C39.3828 106.92 41.6047 109.127 44.3456 109.127Z"
                fill="white"
              />
              <path
                d="M188.478 64.3086H164.301L146.837 66.2375V86.0352H151.247V70.2406H161.082V78.4231H164.11V70.2406H177.77V87.0723H182.179V68.7023L185.224 66.5798V78.0774H188.252V64.478H188.235L188.478 64.3086Z"
                fill="url(#paint14_linear_3921_11748)"
              />
              <path
                d="M192.021 72.9766V78.6078L185.224 87.6027H187.406L192.93 80.6682L198.279 87.6027H200.367L193.601 78.6078V73.1632L192.021 72.9766Z"
                fill="url(#paint15_linear_3921_11748)"
              />
              <path
                d="M198.028 63.5078L191.301 66.1903C191.301 66.1903 189.174 67.6975 187.817 70.8986L186.272 73.1594H196.553C196.553 73.1594 199.807 73.3461 199.58 69.5815C199.58 69.5815 198.856 66.5706 199.184 64.41C199.281 63.7705 198.637 63.2692 198.032 63.5112L198.028 63.5078Z"
                fill="url(#paint16_linear_3921_11748)"
              />
              <path
                d="M164.552 15H163.776V42.2991H164.552V15Z"
                fill="url(#paint17_linear_3921_11748)"
              />
              <path
                d="M161.9 41.501V45.6943L159.655 50.4198C159.655 50.4198 164.782 48.6879 168.989 50.4198C168.989 50.4198 167.03 47.0908 166.494 45.9604V41.501C166.494 41.501 164.816 40.0353 161.903 41.501H161.9Z"
                fill="url(#paint18_linear_3921_11748)"
              />
              <path
                d="M164.183 51.3516C166.634 51.3516 168.62 50.9244 168.62 50.3975C168.62 49.8705 166.634 49.4434 164.183 49.4434C161.732 49.4434 159.746 49.8705 159.746 50.3975C159.746 50.9244 161.732 51.3516 164.183 51.3516Z"
                fill="#F7C64B"
              />
              <path
                d="M173.969 27.2461H173.395V47.4378H173.969V27.2461Z"
                fill="url(#paint19_linear_3921_11748)"
              />
              <path
                d="M172.006 46.8442V49.945L170.346 53.4399C170.346 53.4399 174.14 52.1609 177.251 53.4399C177.251 53.4399 175.8 50.9786 175.403 50.1421V46.8442C175.403 46.8442 174.164 45.7622 172.006 46.8442Z"
                fill="url(#paint20_linear_3921_11748)"
              />
              <path
                d="M173.693 54.1331C175.506 54.1331 176.975 53.8173 176.975 53.4279C176.975 53.0384 175.506 52.7227 173.693 52.7227C171.881 52.7227 170.412 53.0384 170.412 53.4279C170.412 53.8173 171.881 54.1331 173.693 54.1331Z"
                fill="#F7C64B"
              />
              <path
                d="M205.479 75.6042L202.062 74.3631V54.2578H205.479V75.6042Z"
                fill="url(#paint21_linear_3921_11748)"
              />
              <path
                d="M212.074 78.0763L204.717 75.3972V47.0195H212.074V78.0763Z"
                fill="url(#paint22_linear_3921_11748)"
              />
              <path
                d="M215.05 79.3637L210.595 77.5592V58.5117H215.05V79.3637Z"
                fill="url(#paint23_linear_3921_11748)"
              />
              <path
                d="M213.439 43.6309H210.595V58.5128H213.439V43.6309Z"
                fill="url(#paint24_linear_3921_11748)"
              />
              <path
                d="M204.717 48.7656H203.293V54.3693H204.717V48.7656Z"
                fill="url(#paint25_linear_3921_11748)"
              />
              <path
                d="M42.95 129.711H33.5151C32.7463 129.711 32.123 130.33 32.123 131.094V137.129C32.123 137.893 32.7463 138.512 33.5151 138.512H42.95C43.7188 138.512 44.3421 137.893 44.3421 137.129V131.094C44.3421 130.33 43.7188 129.711 42.95 129.711Z"
                fill="url(#paint26_linear_3921_11748)"
              />
              <path d="M208.396 141.699H30.543V153.487H208.396V141.699Z" fill="white" />
              <path
                d="M42.95 143.273H33.5151C32.7463 143.273 32.123 143.893 32.123 144.656V150.692C32.123 151.456 32.7463 152.075 33.5151 152.075H42.95C43.7188 152.075 44.3421 151.456 44.3421 150.692V144.656C44.3421 143.893 43.7188 143.273 42.95 143.273Z"
                fill="url(#paint27_linear_3921_11748)"
              />
              <path
                d="M62.2543 67.6517C63.2999 67.6517 64.1476 66.8098 64.1476 65.7712C64.1476 64.7326 63.2999 63.8906 62.2543 63.8906C61.2087 63.8906 60.3611 64.7326 60.3611 65.7712C60.3611 66.8098 61.2087 67.6517 62.2543 67.6517Z"
                fill="white"
              />
              <path
                d="M58.6523 72.7367C59.9632 72.7367 61.0258 71.6812 61.0258 70.3791C61.0258 69.077 59.9632 68.0215 58.6523 68.0215C57.3415 68.0215 56.2788 69.077 56.2788 70.3791C56.2788 71.6812 57.3415 72.7367 58.6523 72.7367Z"
                fill="white"
              />
              <path
                d="M64.1512 75.5103C64.8393 75.5103 65.3971 74.9562 65.3971 74.2727C65.3971 73.5892 64.8393 73.0352 64.1512 73.0352C63.4631 73.0352 62.9053 73.5892 62.9053 74.2727C62.9053 74.9562 63.4631 75.5103 64.1512 75.5103Z"
                fill="white"
              />
              <path
                d="M64.085 74.7181L56.8914 70.4764L61.3739 66.2383L62.0943 66.9884L58.6106 70.2829L64.6174 73.8262L64.085 74.7181Z"
                fill="white"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_3921_11748"
              x="135"
              y="114"
              width="240"
              height="192"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="6"
                operator="erode"
                in="SourceAlpha"
                result="effect1_dropShadow_3921_11748"
              />
              <feOffset dy="9" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_3921_11748"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.352941 0 0 0 0 0.380392 0 0 0 0 0.415686 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_3921_11748"
                result="effect2_dropShadow_3921_11748"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_3921_11748"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_dd_3921_11748"
              x="0"
              y="0"
              width="240"
              height="189"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="6"
                operator="erode"
                in="SourceAlpha"
                result="effect1_dropShadow_3921_11748"
              />
              <feOffset dy="9" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_3921_11748"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.352941 0 0 0 0 0.380392 0 0 0 0 0.415686 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_3921_11748"
                result="effect2_dropShadow_3921_11748"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_3921_11748"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_3921_11748"
              x1="167.123"
              y1="137.518"
              x2="179.342"
              y2="137.518"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_3921_11748"
              x1="159"
              y1="151.29"
              x2="159.348"
              y2="151.29"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_3921_11748"
              x1="99.5927"
              y1="175.434"
              x2="284.817"
              y2="260.343"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_3921_11748"
              x1="116.607"
              y1="144.771"
              x2="298.886"
              y2="228.33"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_3921_11748"
              x1="104.19"
              y1="172.808"
              x2="286.468"
              y2="256.367"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_3921_11748"
              x1="122.879"
              y1="133.02"
              x2="305.157"
              y2="216.579"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_3921_11748"
              x1="110.462"
              y1="161.056"
              x2="292.74"
              y2="244.616"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_3921_11748"
              x1="324.267"
              y1="227.71"
              x2="319.387"
              y2="282.061"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.33" stopColor="#FEEDB8" />
              <stop offset="1" stopColor="#FBCA2B" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_3921_11748"
              x1="24"
              y1="99.9019"
              x2="138.283"
              y2="99.9019"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#3F20AE" />
              <stop offset="1" stopColor="#5372E5" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_3921_11748"
              x1="124.693"
              y1="64.8692"
              x2="216"
              y2="64.8692"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#537CE3" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_3921_11748"
              x1="136.985"
              y1="31.2474"
              x2="216"
              y2="31.2474"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9BD7F2" />
              <stop offset="0.16" stopColor="#ABDDF4" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_3921_11748"
              x1="170.667"
              y1="108.511"
              x2="169.918"
              y2="81.7646"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8BBFD" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_3921_11748"
              x1="51.3296"
              y1="69.722"
              x2="71.1216"
              y2="69.722"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_3921_11748"
              x1="30.9258"
              y1="98.392"
              x2="44.0914"
              y2="98.392"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_3921_11748"
              x1="139.47"
              y1="53.8515"
              x2="226.08"
              y2="120.246"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.16" stopColor="#FEEDB8" />
              <stop offset="0.41" stopColor="#FBCA2B" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_3921_11748"
              x1="145.334"
              y1="58.7998"
              x2="278.858"
              y2="125.061"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_3921_11748"
              x1="210.125"
              y1="70.3317"
              x2="227.475"
              y2="72.3354"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_3921_11748"
              x1="163.776"
              y1="28.6478"
              x2="164.552"
              y2="28.6478"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_3921_11748"
              x1="159.655"
              y1="45.6355"
              x2="168.989"
              y2="45.6355"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.47" stopColor="#3EABF0" />
              <stop offset="1" stopColor="#2AFFF6" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_3921_11748"
              x1="173.395"
              y1="37.3402"
              x2="173.969"
              y2="37.3402"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint20_linear_3921_11748"
              x1="170.346"
              y1="49.9035"
              x2="177.251"
              y2="49.9035"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.47" stopColor="#3EABF0" />
              <stop offset="1" stopColor="#2AFFF6" />
            </linearGradient>
            <linearGradient
              id="paint21_linear_3921_11748"
              x1="114.84"
              y1="24.57"
              x2="242.263"
              y2="82.2845"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint22_linear_3921_11748"
              x1="116.786"
              y1="20.27"
              x2="244.209"
              y2="77.9842"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint23_linear_3921_11748"
              x1="21.1594"
              y1="11.4115"
              x2="86.7934"
              y2="31.147"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.23" stopColor="#5375DE" />
              <stop offset="0.51" stopColor="#558DD1" />
              <stop offset="0.77" stopColor="#569BC9" />
              <stop offset="1" stopColor="#57A0C7" />
            </linearGradient>
            <linearGradient
              id="paint24_linear_3921_11748"
              x1="210.595"
              y1="51.0701"
              x2="213.439"
              y2="51.0701"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.36" stopColor="#5474D7" />
              <stop offset="0.71" stopColor="#5682CB" />
              <stop offset="1" stopColor="#5787C7" />
            </linearGradient>
            <linearGradient
              id="paint25_linear_3921_11748"
              x1="203.293"
              y1="51.5657"
              x2="204.717"
              y2="51.5657"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.36" stopColor="#5474D7" />
              <stop offset="0.71" stopColor="#5682CB" />
              <stop offset="1" stopColor="#5787C7" />
            </linearGradient>
            <linearGradient
              id="paint26_linear_3921_11748"
              x1="32.123"
              y1="134.112"
              x2="44.3421"
              y2="134.112"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint27_linear_3921_11748"
              x1="32.123"
              y1="147.674"
              x2="44.3421"
              y2="147.674"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <clipPath id="clip0_3921_11748">
              <rect x="159" y="129" width="192" height="144" rx="3" fill="white" />
            </clipPath>
            <clipPath id="clip1_3921_11748">
              <rect x="24" y="15" width="192" height="141" rx="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width="653"
          height="389"
          viewBox="0 0 653 389"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_dd_13705_137934)">
            <g clipPath="url(#clip0_13705_137934)">
              <path d="M533.671 181.248H320.781V356H533.671V181.248Z" fill="white" />
              <path d="M629 120H309V356.119H629V120Z" fill="white" />
              <path d="M629 120.627H309V170.401H629V120.627Z" fill="#EAEAEA" />
              <path d="M616.326 124.018H319.905V143.64H616.326V124.018Z" fill="white" />
              <path
                d="M340.583 126.635H324.858C323.577 126.635 322.538 127.665 322.538 128.936V138.983C322.538 140.255 323.577 141.285 324.858 141.285H340.583C341.865 141.285 342.903 140.255 342.903 138.983V128.936C342.903 127.665 341.865 126.635 340.583 126.635Z"
                fill="url(#paint0_linear_13705_137934)"
              />
              <path d="M616.326 146.59H319.905V166.212H616.326V146.59Z" fill="white" />
              <path
                d="M340.583 149.209H324.858C323.577 149.209 322.538 150.239 322.538 151.511V161.558C322.538 162.829 323.577 163.859 324.858 163.859H340.583C341.864 163.859 342.903 162.829 342.903 161.558V151.511C342.903 150.239 341.864 149.209 340.583 149.209Z"
                fill="url(#paint1_linear_13705_137934)"
              />
              <path
                d="M415.651 183.678H331.157C329.876 183.678 328.837 184.708 328.837 185.979V194.076C328.837 195.347 329.876 196.377 331.157 196.377H415.651C416.933 196.377 417.971 195.347 417.971 194.076V185.979C417.971 184.708 416.933 183.678 415.651 183.678Z"
                fill="#AAAAAA"
              />
              <path
                d="M389.138 201.076H331.158C329.876 201.076 328.837 202.107 328.837 203.378V205.121C328.837 206.393 329.876 207.423 331.158 207.423H389.138C390.419 207.423 391.458 206.393 391.458 205.121V203.378C391.458 202.107 390.419 201.076 389.138 201.076Z"
                fill="#AAAAAA"
              />
              <path
                d="M460.842 328.184H331.157C329.876 328.184 328.837 329.214 328.837 330.485V332.62C328.837 333.891 329.876 334.922 331.157 334.922H460.842C462.123 334.922 463.162 333.891 463.162 332.62V330.485C463.162 329.214 462.123 328.184 460.842 328.184Z"
                fill="#D5D6D5"
              />
              <path
                d="M420.338 339.34H331.158C329.876 339.34 328.837 340.37 328.837 341.642V343.776C328.837 345.048 329.876 346.078 331.158 346.078H420.338C421.619 346.078 422.658 345.048 422.658 343.776V341.642C422.658 340.37 421.619 339.34 420.338 339.34Z"
                fill="#D5D6D5"
              />
              <path
                d="M512.378 191.531C512.378 194.587 509.768 197.084 506.577 197.084H483.231C480.041 197.084 477.431 194.587 477.431 191.531C477.431 188.476 480.041 185.979 483.231 185.979H506.577C509.768 185.979 512.378 188.476 512.378 191.531Z"
                fill="#D5D6D5"
              />
              <path
                d="M524.344 196.509C527.064 196.509 529.269 194.322 529.269 191.624C529.269 188.926 527.064 186.738 524.344 186.738C521.624 186.738 519.42 188.926 519.42 191.624C519.42 194.322 521.624 196.509 524.344 196.509Z"
                fill="#D5D6D5"
              />
              <path
                d="M415.651 221.85H331.158C329.876 221.85 328.837 222.88 328.837 224.151V317.998C328.837 319.269 329.876 320.299 331.158 320.299H415.651C416.933 320.299 417.972 319.269 417.972 317.998V224.151C417.972 222.88 416.933 221.85 415.651 221.85Z"
                fill="url(#paint2_linear_13705_137934)"
              />
              <path
                d="M467.796 222.604H431.683C430.402 222.604 429.363 223.634 429.363 224.905V260.772C429.363 262.043 430.402 263.073 431.683 263.073H467.796C469.078 263.073 470.116 262.043 470.116 260.772V224.905C470.116 223.634 469.078 222.604 467.796 222.604Z"
                fill="url(#paint3_linear_13705_137934)"
              />
              <path
                d="M467.796 278.047H431.683C430.402 278.047 429.363 279.077 429.363 280.349V316.215C429.363 317.486 430.402 318.517 431.683 318.517H467.796C469.078 318.517 470.116 317.486 470.116 316.215V280.349C470.116 279.077 469.078 278.047 467.796 278.047Z"
                fill="url(#paint4_linear_13705_137934)"
              />
              <path
                d="M520.226 222.604H484.113C482.831 222.604 481.792 223.634 481.792 224.905V260.772C481.792 262.043 482.831 263.073 484.113 263.073H520.226C521.507 263.073 522.546 262.043 522.546 260.772V224.905C522.546 223.634 521.507 222.604 520.226 222.604Z"
                fill="url(#paint5_linear_13705_137934)"
              />
              <path
                d="M520.226 278.047H484.113C482.831 278.047 481.792 279.077 481.792 280.349V316.215C481.792 317.486 482.831 318.517 484.113 318.517H520.226C521.507 318.517 522.546 317.486 522.546 316.215V280.349C522.546 279.077 521.507 278.047 520.226 278.047Z"
                fill="url(#paint6_linear_13705_137934)"
              />
              <path d="M629 170.402H540.109V354.712H629V170.402Z" fill="#EFEFEF" />
              <path
                d="M629 190.6C629 190.6 594.157 191.75 584.558 224.924C584.558 224.924 579.331 272.414 540.115 277.023V286.535C540.115 286.535 575.196 286.449 589.418 249.575C589.418 249.575 593.687 234.51 596.53 223.002C596.53 223.002 606.483 199.749 629.006 201.078V190.6H629Z"
                fill="#C2E5EF"
              />
              <path
                d="M540.109 312.401L602.214 299.966L620.386 255.968L629 252.205V259.726L624.969 262.557L609.325 302.526L629 329.801V341.563L602.689 307.912L540.109 319.15V312.401Z"
                fill="white"
              />
              <path
                d="M592.869 327.752L540.564 339.745V356.12H614.548C614.548 356.12 623.502 351.615 614.548 342.059L600.883 327.752C600.883 327.752 598.45 326.473 592.875 327.752H592.869Z"
                fill="url(#paint7_linear_13705_137934)"
              />
              <path
                d="M604.064 272.417C608.062 272.417 611.303 269.202 611.303 265.236C611.303 261.27 608.062 258.055 604.064 258.055C600.066 258.055 596.825 261.27 596.825 265.236C596.825 269.202 600.066 272.417 604.064 272.417Z"
                fill="#600AFF"
              />
              <path
                d="M554.889 216.39C558.887 216.39 562.128 213.175 562.128 209.209C562.128 205.243 558.887 202.027 554.889 202.027C550.891 202.027 547.65 205.243 547.65 209.209C547.65 213.175 550.891 216.39 554.889 216.39Z"
                fill="#600AFF"
              />
              <path
                d="M574.987 210.429C578.985 210.429 582.226 207.214 582.226 203.248C582.226 199.282 578.985 196.066 574.987 196.066C570.989 196.066 567.748 199.282 567.748 203.248C567.748 207.214 570.989 210.429 574.987 210.429Z"
                fill="#600AFF"
              />
              <path
                d="M564.436 327.091C568.434 327.091 571.675 323.876 571.675 319.91C571.675 315.944 568.434 312.729 564.436 312.729C560.438 312.729 557.197 315.944 557.197 319.91C557.197 323.876 560.438 327.091 564.436 327.091Z"
                fill="#600AFF"
              />
              <path
                d="M584.552 323.845C588.55 323.845 591.791 320.63 591.791 316.664C591.791 312.698 588.55 309.482 584.552 309.482C580.554 309.482 577.313 312.698 577.313 316.664C577.313 320.63 580.554 323.845 584.552 323.845Z"
                fill="#600AFF"
              />
              <path
                d="M539.53 202.822L570.005 193.949L603.484 170.402H590.921L565.933 187.665L539.53 195.715V202.822Z"
                fill="white"
              />
            </g>
          </g>
          <g filter="url(#filter1_dd_13705_137934)">
            <g clipPath="url(#clip1_13705_137934)">
              <path d="M344 181.934H24V251.001H344V181.934Z" fill="#EAEAEA" />
              <path d="M344 15H24V181.932H344V15Z" fill="white" />
              <path
                d="M214.472 132.277H24V181.933H214.472V132.277Z"
                fill="url(#paint8_linear_13705_137934)"
              />
              <path
                d="M219.582 15L191.822 181.932H344V15H219.582Z"
                fill="url(#paint9_linear_13705_137934)"
              />
              <path
                d="M212.309 58.7423L256.768 69.3828H311.762L344 45.0294V15H219.582L212.309 58.7423Z"
                fill="url(#paint10_linear_13705_137934)"
              />
              <path d="M311.762 69.3828H256.768V110.892H311.762V69.3828Z" fill="white" />
              <path
                d="M344 123.049V181.933H191.822L202.715 116.436L256.768 110.893H311.762L344 123.049Z"
                fill="url(#paint11_linear_13705_137934)"
              />
              <path
                d="M148.679 49.0979C148.679 50.3708 147.635 51.4123 146.359 51.4123H37.2249C35.9488 51.4123 34.9048 50.3708 34.9048 49.0979V40.957C34.9048 39.6841 35.9488 38.6426 37.2249 38.6426H146.359C147.635 38.6426 148.679 39.6841 148.679 40.957V49.0979Z"
                fill="#AAAAAA"
              />
              <path
                d="M121.719 58.7422H37.2249C35.9435 58.7422 34.9048 59.7784 34.9048 61.0566V69.1975C34.9048 70.4757 35.9435 71.5119 37.2249 71.5119H121.719C123 71.5119 124.039 70.4757 124.039 69.1975V61.0566C124.039 59.7784 123 58.7422 121.719 58.7422Z"
                fill="#AAAAAA"
              />
              <path
                d="M61.047 107.652H37.2249C35.9435 107.652 34.9048 108.689 34.9048 109.967V114.121C34.9048 115.399 35.9435 116.436 37.2249 116.436H61.047C62.3284 116.436 63.3671 115.399 63.3671 114.121V109.967C63.3671 108.689 62.3284 107.652 61.047 107.652Z"
                fill="#AAAAAA"
              />
              <path
                d="M108.778 148.096H74.7994C73.518 148.096 72.4792 149.132 72.4792 150.41V153.882C72.4792 155.16 73.518 156.196 74.7994 156.196H108.778C110.059 156.196 111.098 155.16 111.098 153.882V150.41C111.098 149.132 110.059 148.096 108.778 148.096Z"
                fill="#CECECE"
              />
              <path
                d="M108.778 160.246H74.7994C73.518 160.246 72.4792 161.282 72.4792 162.56V166.032C72.4792 167.31 73.518 168.347 74.7994 168.347H108.778C110.059 168.347 111.098 167.31 111.098 166.032V162.56C111.098 161.282 110.059 160.246 108.778 160.246Z"
                fill="#CECECE"
              />
              <path
                d="M103.801 188.754H37.2249C35.9435 188.754 34.9048 189.79 34.9048 191.068V195.223C34.9048 196.501 35.9435 197.537 37.2249 197.537H103.801C105.083 197.537 106.122 196.501 106.122 195.223V191.068C106.122 189.79 105.083 188.754 103.801 188.754Z"
                fill="#AAAAAA"
              />
              <path d="M331.326 204.365H34.9048V224.096H331.326V204.365Z" fill="white" />
              <path
                d="M86.0463 123.048C95.1569 123.048 102.542 115.68 102.542 106.592C102.542 97.5041 95.1569 90.1367 86.0463 90.1367C76.9357 90.1367 69.55 97.5041 69.55 106.592C69.55 115.68 76.9357 123.048 86.0463 123.048Z"
                fill="url(#paint12_linear_13705_137934)"
              />
              <path
                d="M46.517 165.523C52.5779 165.523 57.4913 160.622 57.4913 154.576C57.4913 148.53 52.5779 143.629 46.517 143.629C40.4561 143.629 35.5427 148.53 35.5427 154.576C35.5427 160.622 40.4561 165.523 46.517 165.523Z"
                fill="url(#paint13_linear_13705_137934)"
              />
              <path
                d="M57.909 172.547C62.4771 172.547 66.1803 168.853 66.1803 164.296C66.1803 159.739 62.4771 156.045 57.909 156.045C53.3409 156.045 49.6377 159.739 49.6377 164.296C49.6377 168.853 53.3409 172.547 57.909 172.547Z"
                fill="white"
              />
              <path
                d="M298.131 97.5312H257.835L228.729 100.76V133.896H236.078V107.46H252.47V121.156H257.516V107.46H280.283V135.632H287.632V104.885L292.707 101.333V120.577H297.754V97.8148H297.725L298.131 97.5312Z"
                fill="url(#paint14_linear_13705_137934)"
              />
              <path
                d="M304.036 112.037V121.463L292.708 136.518H296.344L305.55 124.911L314.465 136.518H317.945L306.669 121.463V112.35L304.036 112.037Z"
                fill="url(#paint15_linear_13705_137934)"
              />
              <path
                d="M314.047 96.1898L302.835 100.68C302.835 100.68 299.291 103.202 297.029 108.56L294.453 112.344H311.588C311.588 112.344 317.011 112.657 316.634 106.356C316.634 106.356 315.427 101.316 315.973 97.6999C316.135 96.6295 315.062 95.7905 314.053 96.1956L314.047 96.1898Z"
                fill="url(#paint16_linear_13705_137934)"
              />
              <path
                d="M258.253 15H256.96V60.6922H258.253V15Z"
                fill="url(#paint17_linear_13705_137934)"
              />
              <path
                d="M253.834 59.356V66.3744L250.092 74.2839C250.092 74.2839 258.636 71.3851 265.649 74.2839C265.649 74.2839 262.383 68.712 261.49 66.8199V59.356C261.49 59.356 258.694 56.9027 253.839 59.356H253.834Z"
                fill="url(#paint18_linear_13705_137934)"
              />
              <path
                d="M257.639 75.8462C261.723 75.8462 265.034 75.1313 265.034 74.2493C265.034 73.3673 261.723 72.6523 257.639 72.6523C253.554 72.6523 250.243 73.3673 250.243 74.2493C250.243 75.1313 253.554 75.8462 257.639 75.8462Z"
                fill="#F7C64B"
              />
              <path
                d="M273.949 35.4941H272.992V69.2903H273.949V35.4941Z"
                fill="url(#paint19_linear_13705_137934)"
              />
              <path
                d="M270.678 68.2951V73.4852L267.911 79.3349C267.911 79.3349 274.234 77.194 279.419 79.3349C279.419 79.3349 277 75.2152 276.339 73.815V68.2951C276.339 68.2951 274.274 66.4841 270.678 68.2951Z"
                fill="url(#paint20_linear_13705_137934)"
              />
              <path
                d="M273.491 80.4974C276.512 80.4974 278.961 79.969 278.961 79.3171C278.961 78.6652 276.512 78.1367 273.491 78.1367C270.47 78.1367 268.021 78.6652 268.021 79.3171C268.021 79.969 270.47 80.4974 273.491 80.4974Z"
                fill="#F7C64B"
              />
              <path
                d="M326.465 116.434L320.77 114.357V80.7051H326.465V116.434Z"
                fill="url(#paint21_linear_13705_137934)"
              />
              <path
                d="M337.457 120.577L325.195 116.093V68.5957H337.457V120.577Z"
                fill="url(#paint22_linear_13705_137934)"
              />
              <path
                d="M342.416 122.729L334.992 119.709V87.8281H342.416V122.729Z"
                fill="url(#paint23_linear_13705_137934)"
              />
              <path
                d="M339.731 62.9199H334.992V87.8287H339.731V62.9199Z"
                fill="url(#paint24_linear_13705_137934)"
              />
              <path
                d="M325.195 71.5117H322.823V80.8909H325.195V71.5117Z"
                fill="url(#paint25_linear_13705_137934)"
              />
              <path
                d="M55.5832 206.996H39.8585C38.5771 206.996 37.5383 208.032 37.5383 209.31V219.413C37.5383 220.691 38.5771 221.727 39.8585 221.727H55.5832C56.8646 221.727 57.9034 220.691 57.9034 219.413V209.31C57.9034 208.032 56.8646 206.996 55.5832 206.996Z"
                fill="url(#paint26_linear_13705_137934)"
              />
              <path d="M331.326 227.062H34.9048V246.793H331.326V227.062Z" fill="white" />
              <path
                d="M55.583 229.695H39.8582C38.5768 229.695 37.5381 230.732 37.5381 232.01V242.112C37.5381 243.39 38.5768 244.427 39.8582 244.427H55.583C56.8644 244.427 57.9031 243.39 57.9031 242.112V232.01C57.9031 230.732 56.8644 229.695 55.583 229.695Z"
                fill="url(#paint27_linear_13705_137934)"
              />
              <path
                d="M87.7572 103.125C89.4999 103.125 90.9126 101.716 90.9126 99.9777C90.9126 98.2393 89.4999 96.8301 87.7572 96.8301C86.0145 96.8301 84.6018 98.2393 84.6018 99.9777C84.6018 101.716 86.0145 103.125 87.7572 103.125Z"
                fill="white"
              />
              <path
                d="M81.7539 111.638C83.9387 111.638 85.7098 109.872 85.7098 107.692C85.7098 105.513 83.9387 103.746 81.7539 103.746C79.5692 103.746 77.7981 105.513 77.7981 107.692C77.7981 109.872 79.5692 111.638 81.7539 111.638Z"
                fill="white"
              />
              <path
                d="M90.9188 116.278C92.0657 116.278 92.9953 115.35 92.9953 114.206C92.9953 113.062 92.0657 112.135 90.9188 112.135C89.772 112.135 88.8423 113.062 88.8423 114.206C88.8423 115.35 89.772 116.278 90.9188 116.278Z"
                fill="white"
              />
              <path
                d="M90.8082 114.953L78.8188 107.853L86.2897 100.76L87.4904 102.015L81.6842 107.529L91.6956 113.46L90.8082 114.953Z"
                fill="white"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_13705_137934"
              x="285"
              y="105"
              width="368"
              height="284"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="6"
                operator="erode"
                in="SourceAlpha"
                result="effect1_dropShadow_13705_137934"
              />
              <feOffset dy="9" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13705_137934"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.352941 0 0 0 0 0.380392 0 0 0 0 0.415686 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_13705_137934"
                result="effect2_dropShadow_13705_137934"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_13705_137934"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_dd_13705_137934"
              x="0"
              y="0"
              width="368"
              height="284"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="6"
                operator="erode"
                in="SourceAlpha"
                result="effect1_dropShadow_13705_137934"
              />
              <feOffset dy="9" />
              <feGaussianBlur stdDeviation="15" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_13705_137934"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="0.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.352941 0 0 0 0 0.380392 0 0 0 0 0.415686 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_13705_137934"
                result="effect2_dropShadow_13705_137934"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_13705_137934"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_13705_137934"
              x1="322.538"
              y1="133.96"
              x2="342.903"
              y2="133.96"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_13705_137934"
              x1="309"
              y1="156.534"
              x2="309.58"
              y2="156.534"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_13705_137934"
              x1="209.988"
              y1="196.099"
              x2="516.874"
              y2="339.163"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_13705_137934"
              x1="238.346"
              y1="145.847"
              x2="540.35"
              y2="286.637"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_13705_137934"
              x1="217.65"
              y1="191.796"
              x2="519.654"
              y2="332.586"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_13705_137934"
              x1="248.798"
              y1="126.588"
              x2="550.802"
              y2="267.378"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_13705_137934"
              x1="228.102"
              y1="172.537"
              x2="530.106"
              y2="313.326"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_13705_137934"
              x1="584.446"
              y1="281.774"
              x2="576.579"
              y2="370.871"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.33" stopColor="#FEEDB8" />
              <stop offset="1" stopColor="#FBCA2B" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_13705_137934"
              x1="24"
              y1="157.105"
              x2="214.472"
              y2="157.105"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#3F20AE" />
              <stop offset="1" stopColor="#5372E5" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_13705_137934"
              x1="191.822"
              y1="98.4691"
              x2="344"
              y2="98.4691"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#537CE3" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_13705_137934"
              x1="212.309"
              y1="42.1943"
              x2="344"
              y2="42.1943"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9BD7F2" />
              <stop offset="0.16" stopColor="#ABDDF4" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_13705_137934"
              x1="268.445"
              y1="171.513"
              x2="267.186"
              y2="126.746"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A8BBFD" />
              <stop offset="1" stopColor="#C2E5EF" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_13705_137934"
              x1="69.55"
              y1="106.592"
              x2="102.537"
              y2="106.592"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint13_linear_13705_137934"
              x1="35.5427"
              y1="154.576"
              x2="57.4855"
              y2="154.576"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint14_linear_13705_137934"
              x1="216.45"
              y1="80.0286"
              x2="361.253"
              y2="190.563"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.16" stopColor="#FEEDB8" />
              <stop offset="0.41" stopColor="#FBCA2B" />
            </linearGradient>
            <linearGradient
              id="paint15_linear_13705_137934"
              x1="226.224"
              y1="88.3087"
              x2="449.136"
              y2="198.461"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint16_linear_13705_137934"
              x1="334.209"
              y1="107.611"
              x2="363.128"
              y2="110.937"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint17_linear_13705_137934"
              x1="256.96"
              y1="37.8432"
              x2="258.253"
              y2="37.8432"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint18_linear_13705_137934"
              x1="250.092"
              y1="66.276"
              x2="265.649"
              y2="66.276"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.47" stopColor="#3EABF0" />
              <stop offset="1" stopColor="#2AFFF6" />
            </linearGradient>
            <linearGradient
              id="paint19_linear_13705_137934"
              x1="272.992"
              y1="52.3893"
              x2="273.949"
              y2="52.3893"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint20_linear_13705_137934"
              x1="267.911"
              y1="73.4158"
              x2="279.419"
              y2="73.4158"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.47" stopColor="#3EABF0" />
              <stop offset="1" stopColor="#2AFFF6" />
            </linearGradient>
            <linearGradient
              id="paint21_linear_13705_137934"
              x1="175.401"
              y1="31.0148"
              x2="388.079"
              y2="126.936"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint22_linear_13705_137934"
              x1="178.644"
              y1="23.8235"
              x2="391.321"
              y2="119.744"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="1" stopColor="#57DAC7" />
            </linearGradient>
            <linearGradient
              id="paint23_linear_13705_137934"
              x1="19.2656"
              y1="8.99366"
              x2="128.732"
              y2="41.7699"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.23" stopColor="#5375DE" />
              <stop offset="0.51" stopColor="#558DD1" />
              <stop offset="0.77" stopColor="#569BC9" />
              <stop offset="1" stopColor="#57A0C7" />
            </linearGradient>
            <linearGradient
              id="paint24_linear_13705_137934"
              x1="334.992"
              y1="75.3714"
              x2="339.731"
              y2="75.3714"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.36" stopColor="#5474D7" />
              <stop offset="0.71" stopColor="#5682CB" />
              <stop offset="1" stopColor="#5787C7" />
            </linearGradient>
            <linearGradient
              id="paint25_linear_13705_137934"
              x1="322.823"
              y1="76.1984"
              x2="325.195"
              y2="76.1984"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#525DEC" />
              <stop offset="0.36" stopColor="#5474D7" />
              <stop offset="0.71" stopColor="#5682CB" />
              <stop offset="1" stopColor="#5787C7" />
            </linearGradient>
            <linearGradient
              id="paint26_linear_13705_137934"
              x1="37.5383"
              y1="214.362"
              x2="57.9034"
              y2="214.362"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <linearGradient
              id="paint27_linear_13705_137934"
              x1="37.5381"
              y1="237.061"
              x2="57.9031"
              y2="237.061"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#A3B3FF" />
              <stop offset="1" stopColor="#ABDAC7" />
            </linearGradient>
            <clipPath id="clip0_13705_137934">
              <rect x="309" y="120" width="320" height="236" rx="3" fill="white" />
            </clipPath>
            <clipPath id="clip1_13705_137934">
              <rect x="24" y="15" width="320" height="236" rx="3" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default EmptyTourbooksStateIllustration;
